import Vue from 'vue';

import App from './App.vue';

// plugins
import pinia from '@/plugins/pinia';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import '@/plugins/casl';
import '@/plugins/socket-io';

// filters
import '@/filters';

// global components
import Loading from '@/components/Loading.vue';

// router
import router from './router';

Vue.config.productionTip = false;

Vue.component('Loading', Loading);

new Vue({
  pinia,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
